import { render, staticRenderFns } from "./UnidadeReferentesEditor.vue?vue&type=template&id=ebc6cff6&scoped=true&"
import script from "./UnidadeReferentesEditor.vue?vue&type=script&lang=js&"
export * from "./UnidadeReferentesEditor.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeReferentesEditor.vue?vue&type=style&index=0&id=ebc6cff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc6cff6",
  null
  
)

export default component.exports